import {
  ArrayInput,
  FormDataConsumer,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  SimpleFormIterator,
} from "react-admin";
import { Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { CampaignSubTypes, CitizenshipIds, TaxTypes } from "utils/constants";
import { useFormContext, useWatch } from "react-hook-form";
import { administrationRequests } from "api/administrationApi";

const Taxes = ({ citizenshipIds, examsCount = 0, specialityIds, campaignSubTypeId, isCreate = false }) => {
  const { setValue } = useFormContext();
  const taxes = useWatch({ name: "taxes" });

  const showExamTaxes =
    citizenshipIds?.includes(CitizenshipIds.Bulgarians) &&
    (campaignSubTypeId === CampaignSubTypes.Preliminary || campaignSubTypeId === CampaignSubTypes.Regular);

  const showExamTaxesForForeigners =
    (citizenshipIds?.includes(CitizenshipIds.EuForeigners) ||
      citizenshipIds?.includes(CitizenshipIds.NotEuForeigners)) &&
    campaignSubTypeId === CampaignSubTypes.Preliminary;

  const showSpecialitiesTaxes =
    (citizenshipIds?.includes(CitizenshipIds.EuForeigners) ||
      citizenshipIds?.includes(CitizenshipIds.NotEuForeigners)) &&
    campaignSubTypeId === CampaignSubTypes.Regular;

  useEffect(() => {
    if (!isCreate) return;

    const nextTaxes = [];

    nextTaxes.push({
      taxTypeId: TaxTypes.CandidateDocumentProcessing,
      priceLeva: null,
      priceEuro: null,
    });
    if (campaignSubTypeId === CampaignSubTypes.Preparatory) {
      for (let i = 0; i < examsCount; i++) {
        nextTaxes.push({
          taxTypeId: TaxTypes.CandidateCourses,
          sourceValue: i + 1,
          priceLeva: null,
          priceEuro: null,
        });
      }
    }
    if (showExamTaxes || showExamTaxesForForeigners)
      for (let i = 0; i < examsCount; i++) {
        nextTaxes.push({
          taxTypeId: TaxTypes.CandidateExams,
          sourceValue: i + 1,
          priceLeva: null,
          priceEuro: null,
        });
      }
    if (showSpecialitiesTaxes) {
      specialityIds.forEach(id => {
        nextTaxes.push({
          taxTypeId: TaxTypes.CandidateSpecialities,
          sourceValue: id,
          priceLeva: null,
          priceEuro: null,
        });
      });
    }
    setValue("taxes", nextTaxes, {
      shouldDirty: true,
      shouldTouch: false,
    });
  }, [isCreate, examsCount, setValue, campaignSubTypeId, showSpecialitiesTaxes, showExamTaxes, specialityIds]);

  return (
    <>
      <Grid
        item
        xs={12}
        md={12}
      >
        <Typography color={"primary"}>Такси</Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={12}
        spacing={2}
        container
      >
        <ArrayInput
          label=""
          source="taxes"
          sx={{ ml: 2 }}
        >
          <SimpleFormIterator
            disableAdd
            disableRemove
            disableReordering
            getItemLabel={index => {
              const tax = taxes?.[index];
              if (tax?.taxTypeId === TaxTypes.CandidateExams)
                return `Такса за явяване на ${index} ${index > 1 ? "изпита" : "изпит"}`;
              if (tax?.taxTypeId === TaxTypes.CandidateDocumentProcessing) return "Такса за обработка на документи";
              if (tax?.taxTypeId === TaxTypes.Semester) return "Такса за семестър";
              if (tax?.taxTypeId === TaxTypes.CandidateSpecialities) return "Такса за кандидатстване за специалност";
              if (tax?.taxTypeId === TaxTypes.CandidateCourses)
                return `Такса за ${index} ${index > 1 ? "курса" : "курс"}`;
            }}
          >
            <Grid
              container
              spacing={2}
            >
              <FormDataConsumer>
                {({ scopedFormData }) => {
                  if (scopedFormData?.taxTypeId === TaxTypes.CandidateSpecialities) {
                    return (
                      <Grid
                        item
                        xs={12}
                        md={6}
                      >
                        <ReferenceInput
                          source="sourceValue"
                          reference={administrationRequests.getSpecialitiesSelect()}
                          readOnly
                        >
                          <SelectInput
                            label="Специалност"
                            optionText="name"
                            readOnly
                          />
                        </ReferenceInput>
                      </Grid>
                    );
                  }
                  return null;
                }}
              </FormDataConsumer>
              <Grid
                item
                xs={12}
                md={3}
              >
                <NumberInput
                  source="priceLeva"
                  label="Цена в лева"
                  validate={required()}
                  onWheel={e => e.target.blur()}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
              >
                <NumberInput
                  source="priceEuro"
                  label="Цена в евро"
                  validate={required()}
                  onWheel={e => e.target.blur()}
                />
              </Grid>
            </Grid>
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </>
  );
};

export default Taxes;
